module.exports = __webpack_public_path__ + "img/彩鸢.457ae3b6.jpg";